import {createReducer} from '@reduxjs/toolkit';
import {
    getContractLimitsSuccess,
    saveContractLimitsSuccess,
} from 'src/openapi/admin/apis/LimitControllerApi';

import type {LimitList} from 'src/openapi/admin/models/LimitList';

export type State = Record<string, LimitList | null>;

const initialState: State = {};

export const contractData = createReducer(initialState, builder => builder
    .addCase(getContractLimitsSuccess, (state, action) => {
        const {contractId} = action.payload.meta;
        return {
            ...state,
            [contractId]: action.payload.data,
        };
    })
    .addCase(saveContractLimitsSuccess, (state, action) => {
        const {contractId, apiLimit} = action.payload.meta;

        return {
            ...state,
            [contractId]: {
                limits: apiLimit,
                changesInfo: action.payload.data,
            },
        };
    }),
);
